import React, { type FC } from "react";
import { BusinessList } from "@src/components/business-list";
import type { UseStockGatheringCompletionReservesQueryResult } from "../../hooks";
import { StockGatheringCompletionReserveListItem } from "./StockGatheringCompletionReserveListItem";

/** Пропсы компонента {@link StockGatheringCompletionReservesList}. */
interface StockGatheringCompletionReservesListProps {
    /** Query-result резервов КВ. */
    reservesQuery: UseStockGatheringCompletionReservesQueryResult;
    /**
     * Открывает форму комплектования резерва.
     * @param reserveCode код резерва
     */
    onOpenReserve: (reserveCode: number) => void;
}

/** Список резервов по строкам состава КВ. */
export const StockGatheringCompletionReservesList: FC<StockGatheringCompletionReservesListProps> = ({
    reservesQuery,
    onOpenReserve,
}) => {
    const { reserves, isFetching } = reservesQuery;

    return (
        <BusinessList isLoad={isFetching} emptyText="Список резервов пуст">
            {reserves.map((item, index) => (
                <StockGatheringCompletionReserveListItem
                    key={item.Code}
                    reserve={item}
                    index={index}
                    onSelect={onOpenReserve}
                />
            ))}
        </BusinessList>
    );
};
